import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ListResource } from '../../../../components/ListResource/ListResource';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { useErrorMessage } from '../../../../utils/errorMessage';
import { createSupervisionColumns } from '../../../../utils/createSupervisionColumns';

const ListSupervisions = ({ pensioner }) => {
  const { t } = useTranslation();
  const { dispatchAPI } = useAuthContext();
  const { message } = useErrorMessage();
  const navigate = useNavigate();
  const [refreshData, setRefreshData] = useState(false);

  const columns = createSupervisionColumns({
    t,
    dispatchAPI,
    message,
    setRefreshData,
    refreshData
  });

  return (
    <ListResource
      resourceName="supervisions"
      extraQuery={`pensioners=${pensioner._id}`}
      populate="pensioners,petsitting_address"
      columns={columns}
      showEdit={false}
      withPageHeader={false}
      withCreateButton={false}
      forceRefresh={refreshData}
      customActionColumn
      onDoubleClickAction={{
        action: (record) => {
          navigate(`/supervisions/show/${record?._id}`);
        }
      }}
    />
  );
};

export default ListSupervisions;

ListSupervisions.propTypes = {
  pensioner: PropTypes.shape({
    _id: PropTypes.string.isRequired
  }).isRequired
};
